export default {
    baseStyle: {
        dotsRow: {
            align: 'center',
            justify: 'center',
            maxWidth: '260px',
            marginX: 'auto',
            marginBottom: 3
        },
        dot: {
            width: '30px',
            height: '30px',
            borderRadius: 'full',
            flexShrink: 0
        },
        dotActive: {
            backgroundColor: 'yellow.600'
        },
        dotCompleted: {
            backgroundColor: 'yellow.400'
        },
        dotUpcoming: {
            backgroundColor: 'gray.375'
        },
        connector: {
            flex: 'none',
            width: '48px',
            height: '1px',
            backgroundColor: 'gray.375',
            marginX: '6px'
        },
        labelsRow: {
            align: 'center',
            justify: 'center',
            gap: '5px',
            fontFamily: 'body'
        },
        labelGroup: {
            align: 'center',
            gap: '6px'
        },
        label: {
            fontSize: '14px',
            lineHeight: '24px',
            color: 'black.100',
            fontWeight: '300'
        },
        labelActive: {
            fontWeight: '400'
        },
        chevron: {
            width: '7px',
            height: '11px',
            color: 'black.100'
        }
    }
}
